import React, {useEffect, useState} from 'react';
import '../Body.css';
import './VerwaltungWettkampf.css';
import NavbarDisziplin from "../components/NavbarDisziplin";
import apiService from "../services/ApiService";
import ApiService from "../services/ApiService";

function VerwaltungWettkampf(token) {
    const [displayText, setDisplayText] = useState('');
    const [loading, setLoading] = useState(false);
    const [disziplinList, setDisziplinList] = useState([]);
    const [ligaList, setLigaList] = useState([]);
    const [mannschaftenList, setMannschaftenList] = useState([]);

    const [showGeneratedMatchups, setShowGeneratedMatchups] = useState(false);
    const [isSaveSuccessful, setIsSaveSuccessful] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [selectedLiga, setSelectedLiga] = useState();
    const [selectedDisziplin, setSelectedDisziplin] = useState(null);
    const [paarungen, setPaarungen] = useState([]);

    // Hilfsfunktion, um sicherzustellen, dass das Element in rule existiert
    const isExistingRuleElement = (rule, index) => {
        return index < rule.length;
    };

    const generateSyncMatchups = (ligaId) => {
        setIsSaveSuccessful(false);
        setHasError(false);
        setPaarungen([]);
        setSelectedLiga(ligaId);
        const filteredMannschaftItems = mannschaftenList
            .filter((item) => item.liga !== null && item.liga.id === ligaId)
            .sort((a, b) => a.position - b.position);
        const countOfMannschaften = filteredMannschaftItems.length;
        if (countOfMannschaften === 5 || countOfMannschaften === 6) {
            setShowGeneratedMatchups(true)
            const rules = [
                [4, 1, 5, 3, 2, 6],
                [1, 2, 3, 4, 5, 6],
                [1, 3, 2, 5, 4, 6],
                [5, 1, 4, 2, 3, 6],
                [4, 5, 2, 3, 1, 6]
            ];
            for (const rule of rules) {
                let newDurchgang = [];

                // Funktion, um "ohne Gegner" zu setzen, wenn keine entsprechende Mannschaft vorhanden ist
                const getMannschaftName = (index) => {
                    const item = filteredMannschaftItems[index - 1];//filteredMannschaftItems=item.man.name
                    if (item) {
                        return item;
                    }
                    return "ohne Gegner";
                };
                newDurchgang.push([
                    getMannschaftName(rule[0]).mannschaft.id,
                    getMannschaftName(rule[1]).mannschaft.id
                ]);
                newDurchgang.push([
                    getMannschaftName(rule[2]).mannschaft.id,
                    getMannschaftName(rule[3]).mannschaft.id
                ]);
                if (countOfMannschaften === 5) {
                    newDurchgang.push([
                        getMannschaftName(rule[4]).mannschaft.id,
                        0
                    ]);
                } else {
                    newDurchgang.push([
                        getMannschaftName(rule[4]).mannschaft.id,
                        getMannschaftName(rule[5]).mannschaft.id
                    ]);
                }
                setPaarungen((prevPaarungen) => [...prevPaarungen, newDurchgang]);
            }
        }
        if (countOfMannschaften === 7) {
            setShowGeneratedMatchups(true)
            const rules = [
                [4, 1, 5, 3, 2, 6],
                [7, 3, 1, 2, 4, 6, 5, 7],
                [7, 1, 3, 2, 6, 5],
                [4, 2, 5, 1, 7, 4, 3, 6],
                [3, 4, 2, 5, 7, 6],
                [1, 6, 1, 3, 4, 5, 2, 7]
            ];
            for (const rule of rules) {
                let newDurchgang = [];
                // Funktion, um "ohne Gegner" zu setzen, wenn keine entsprechende Mannschaft vorhanden ist
                const getMannschaftName = (index) => {
                    const item = filteredMannschaftItems[index - 1];//filteredMannschaftItems=man1,man2,man3,man4,man5
                    if (item) {
                        return item;
                    }
                    return "ohne Gegner";
                };
                newDurchgang.push([
                    getMannschaftName(rule[0]).mannschaft.id,
                    getMannschaftName(rule[1]).mannschaft.id
                ]);
                newDurchgang.push([
                    getMannschaftName(rule[2]).mannschaft.id,
                    getMannschaftName(rule[3]).mannschaft.id
                ]);
                newDurchgang.push([
                    getMannschaftName(rule[4]).mannschaft.id,
                    getMannschaftName(rule[5]).mannschaft.id
                ]);
                if (isExistingRuleElement(rule, 6)) {
                    newDurchgang.push([
                        getMannschaftName(rule[6]).mannschaft.id,
                        getMannschaftName(rule[7]).mannschaft.id
                    ]);
                }
                setPaarungen((prevPaarungen) => [...prevPaarungen, newDurchgang]);
            }
        }
    }
    const generateAsyncMatchups = (ligaId) => {
        setIsSaveSuccessful(false);
        setHasError(false);
        setPaarungen([]);
        setSelectedLiga(ligaId);
        const filteredMannschaften = mannschaftenList
            .filter((item) => item.liga !== null && item.liga.id === ligaId)
            .sort((a, b) => a.position - b.position);
        const countOfMannschaften = filteredMannschaften.length;
        if (countOfMannschaften === 6) {
            setShowGeneratedMatchups(true)
            const rules = [
                [4, 1, 2, 6, 5, 3],
                [1, 2, 3, 4, 6, 5],
                [1, 3, 2, 5, 4, 6],
                [5, 1, 4, 2, 3, 7, 6, 7],
                [3, 6, 4, 5, 1, 7, 2, 7],
                [1, 6, 2, 3, 4, 7, 5, 7]
            ];
            for (const rule of rules) {
                console.log("in rule: " + rule);
                let newDurchgang = [];

                // Funktion, um "ohne Gegner" zu setzen, wenn keine entsprechende Mannschaft vorhanden ist
                const getMannschaftName = (index) => {
                    console.log("index async: " + index);
                    const item = filteredMannschaften[index - 1];
                    if (item) {
                        return item.mannschaft.id;
                    }
                    return 0;
                };
                newDurchgang.push([
                    getMannschaftName(rule[0]),
                    getMannschaftName(rule[1])
                ]);
                newDurchgang.push([
                    getMannschaftName(rule[2]),
                    getMannschaftName(rule[3])
                ]);
                newDurchgang.push([
                    getMannschaftName(rule[4]),
                    getMannschaftName(rule[5])
                ]);
                if (isExistingRuleElement(rule, 6)) {
                    newDurchgang.push([
                        getMannschaftName(rule[6]),
                        getMannschaftName(rule[7])
                    ]);
                }
                console.log("done");
                setPaarungen((prevPaarungen) => [...prevPaarungen, newDurchgang]);
            }
        }
    }

    const handleDisziplinClick = (selectedCode) => {
        const disziplin = disziplinList.find(dis => dis.code === selectedCode);
        setSelectedDisziplin(disziplin);
        setShowGeneratedMatchups(false);
        setIsSaveSuccessful(false);
        setHasError(false);
        apiService.fetchLigenByDisziplin(selectedCode)
            .then(data => {
                setLigaList(data);
                setLoading(false);
            })
            .catch(error => console.error('Fehler beim Laden der Ligen:', error));

        apiService.fetchMannschaftenByDisziplin(2026, selectedCode)
            .then(data => {
                setMannschaftenList(data);
                setLoading(false);
            })
            .catch(error => console.error('Fehler beim Laden der Liste:', error));
    };

    useEffect(() => {
        setLoading(true);
        ApiService.fetchDisziplin()
            .then(data => {
                setDisziplinList(data);
                setLoading(false);
            })
            .catch(error => console.error('Fehler beim Laden der Disziplinen:', error));
    }, []);

    if (loading) {
        return <p>Loading...</p>;
    }

    const handleSave = async () => {
        try {
            const response = await ApiService.createWettkampf(token, selectedLiga, paarungen);
            if (response) {
                setDisplayText(`Daten erfolgreich gespeichert`);
                setHasError(false);
                setIsSaveSuccessful(true);
            } else {
                setIsSaveSuccessful(false)
                setHasError(true);
                console.error('Fehler beim Speichern der Daten');
                setDisplayText('Fehler beim Speichern der Daten');
            }
        } catch
            (error) {
            setHasError(true);
            console.error('Fehler beim API-Aufruf', error);
            setDisplayText('Fehler beim API-Aufruf');
        }
    };

    return (
        <div className="element-content element-background">
            <p style={{color: 'red', alignItems: 'center'}}>!!! ADMINBEREICH => nur von Jochen zu benutzen !!!</p>
            <div className="grid-verwaltung-wettkampf">
                <div className="top-panel-liste">
                    <NavbarDisziplin disziplinList={disziplinList} handleDisziplinClick={handleDisziplinClick} selectedDisziplin={selectedDisziplin}/>
                </div>
                <div className="left-panel-wettkampf">
                    {ligaList.map((liga) => {
                            const filteredMannschaften = mannschaftenList
                                .filter((mannschaft) => mannschaft.liga !== null)
                                .filter((mannschaft) => mannschaft.liga.id === liga.id)
                                .sort((a, b) => a.position - b.position);

                            return (
                                <div key={liga.name}>
                                    <strong>{liga.name} </strong>
                                    <div>
                                        <button onClick={() => generateSyncMatchups(liga.id)}>
                                            generiere 5 Durchgänge
                                        </button>
                                        {filteredMannschaften.length === 6 && (
                                            <button onClick={() => generateAsyncMatchups(liga.id)}>
                                                generiere 6 Durchgänge</button>
                                        )}
                                    </div>
                                    {filteredMannschaften.map((item, index) => (
                                        <div key={item.id}>
                                            {`${index + 1}. ${item.mannschaft.name}`}
                                        </div>
                                    ))}
                                </div>
                            )
                        }
                    )}
                </div>
                {showGeneratedMatchups && (
                    <div className="right-panel-wettkampf">
                        {paarungen.map((durchgang, index) => (
                            <div key={`Wettkampf${index}`}>
                                <h3>{index + 1}. Wettkampf</h3>
                                {durchgang.map((pair, pairIndex) => (
                                    <div key={`Paar${pairIndex}`}>
                                        <div className="paarungen">
                                            {mannschaftenList.find((item) => item.mannschaft.id === pair[0]).mannschaft.name}
                                            :
                                            {pair[1] !== 0 ?
                                                mannschaftenList.find((item) => item.mannschaft.id === pair[1]).mannschaft.name
                                                : "ohne Gegner"
                                            }</div>
                                    </div>
                                ))}
                            </div>
                        ))}
                        <button
                            className={`saveButton ${isSaveSuccessful ? 'success' : ''} ${hasError ? 'error' : ''}`}
                            onClick={handleSave}>Speichern
                        </button>
                        <div
                            className={`hint ${isSaveSuccessful ? 'success' : ''} ${hasError ? 'error' : ''}`}>{displayText} </div>
                    </div>
                )}
                {!showGeneratedMatchups && ligaList.length > 0 && (
                    <div className="right-panel-wettkampf">
                        <p> Wähle, für welche Liga Wettkämpfe generiert werden sollen</p>
                    </div>
                )}
                {!showGeneratedMatchups && ligaList.length === 0 && (
                    <div className="right-panel-wettkampf">
                        <p> Wähle, eine Disziplin aus</p>
                    </div>
                )}

            </div>
        </div>
    )
        ;
}

export default VerwaltungWettkampf;

